import moment from 'moment';
import { AttributeDefinitionValueListItem } from './attributeDefinitionValueListItem';
import { AttributeUiType } from './attributeUiType';
import _ from 'lodash';

export class ComplexAttributeSubFieldValue {
  public subFieldDefinitionItemId: string;
  public groupId: number;
  public value: string;
  public name: string;
  public type: string;
  public rank: number;
  public attributeDefinitionValueListItem: AttributeDefinitionValueListItem;

  constructor(
    subFieldDefinitionItemId: string,
    groupId: number,
    value: string,
    name: string,
    type: string,
    rank: number,
    attributeDefinitionValueListItem: AttributeDefinitionValueListItem
  ) {
    this.subFieldDefinitionItemId = subFieldDefinitionItemId;
    this.groupId = groupId;
    this.value = value;
    this.name = name;
    this.type = type;
    this.rank = rank;
    this.attributeDefinitionValueListItem = attributeDefinitionValueListItem
      ? AttributeDefinitionValueListItem.parse(attributeDefinitionValueListItem)
      : null;
  }
  isDateType(): boolean {
    return this.type === AttributeUiType.Date;
  }

  isDropDownType(): boolean {
    return this.type === AttributeUiType.DropDown;
  }

  isNumberType(): boolean {
    return this.type === AttributeUiType.Number;
  }

  isShortAnswerType(): boolean {
    return this.type === AttributeUiType.ShortAnswer;
  }

  isLongAnswerType(): boolean {
    return this.type === AttributeUiType.LongAnswer;
  }

  isCheckboxType(): boolean {
    return this.type === AttributeUiType.Checkboxes;
  }

  isMultiSelectType(): boolean {
    return this.type === AttributeUiType.MultiSelect;
  }

  isSkillType(): boolean {
    return this.type === AttributeUiType.Skill;
  }

  isStarRatingType(): boolean {
    return this.type === AttributeUiType.StarRating;
  }

  isDateRangeType(): boolean {
    return this.type === AttributeUiType.DateRange;
  }

  hasValue(): boolean {
    let hasValue = false;
    if (
      this.isDropDownType() ||
      this.isCheckboxType() ||
      this.isMultiSelectType() ||
      this.isSkillType() ||
      this.isStarRatingType()
    ) {
      hasValue = !_.isNil(this.attributeDefinitionValueListItem);
    } else if (typeof this.value === 'string') {
      hasValue = !_.isEmpty(this.value.trim());
    } else if (typeof this.value === 'number') {
      hasValue = !isNaN(Number(this.value));
    } else if (this.isDateType()) {
      hasValue = this.value !== undefined && moment(this.value, 'MM/DD/YYYY').isValid();
    }
    return hasValue;
  }
  static parse(obj: Partial<ComplexAttributeSubFieldValue>): ComplexAttributeSubFieldValue {
    return new ComplexAttributeSubFieldValue(
      obj.subFieldDefinitionItemId,
      obj.groupId,
      obj.value,
      obj.name,
      obj.type,
      obj.rank,
      obj.attributeDefinitionValueListItem
    );
  }
}
